import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.white,
  iconColor: colors.petsuitesPurple,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default accordion;